import { COMP_LOAD_STATE_NAV } from "../constants";
import { ComponentManager } from "../utils";
import { LoadStateGroupNav } from "../components/load_state_group_nav";

export class LectrosonicsOptions {
  constructor($container, controller) {

    this._initialized = false;
    this.$container = $container;
    this.controller = controller;
    this.components = new ComponentManager();
    this.components.add(COMP_LOAD_STATE_NAV, new LoadStateGroupNav(this));
  }

  async init() {
    if (this._initialized) {
      return;
    }

    const me = this;
    this.$container.find('.lectrosonics-options select').change(function () {
      me.$container.trigger('lectrosonics-selected', {
        id: me.$container.attr('id'),
        value: $(this).find('option:selected').val()
      });
      if ($(this).find('option:selected').val()) {
        me.$container.addClass('has-selection');
      } else {
        me.$container.removeClass('has-selection');
      }

      me.controller.validate();
    });

    await this.iemChange();

    this._initialized = true;
  }

  async loadState() {
    if (this.controller.state.lectrosonics_code) {
      const iem_code = this.controller.state.iem_code;
      const lectrosonics_code = this.controller.state.lectrosonics_code
      const $cableOptions = this.$container.find(`.lectrosonics-options[data-iem=${iem_code}]`);
      $cableOptions
        .find(`option[value=${lectrosonics_code}]`)
        .prop('selected', true)
        .change();

      this.components.broadcast('onStateLoaded');
    }
  }

  async iemChange() {
    const iem_code = this.controller.state.iem_code;
    const $optionsToDisplay = this.$container.find(`.lectrosonics-options[data-iem=${iem_code}]`);
    this.$container.find('.lectrosonics-options').not($optionsToDisplay).hide();
    $optionsToDisplay.find('select option').removeAttr('selected');
    this.$container.removeClass('has-selection');
    $optionsToDisplay.show();
    if ($optionsToDisplay.find('select option').length < 2) {
      this.$container.addClass("not-available");
    } else {
      this.$container.removeClass("not-available");
    }
  }
}